import { AccessDashboardGuard } from './access-dashboard.guard';
import { ClientViewCustomerDataGuard } from './client/view-customer-data.guard';
import { ModifyProductDataGuard } from './modify-product-data.guard';
import { ViewCustomerDataGuard } from './view-customer-data.guard';

export const PERMISSION_GUARDS = [
  ModifyProductDataGuard,
  ViewCustomerDataGuard,
  ClientViewCustomerDataGuard,
  AccessDashboardGuard,
];



// WEBPACK FOOTER //
// ./src/app/services/routing/permission-guards/index.ts